import React from 'react'
import PropTypes from 'prop-types'
import { constants } from 'common/helpers'
import actions from 'redux/actions'
import { useCallback, useMemo } from 'sb-hooks'

import ModalContainer from 'components/_new/modal/ModalContainer/ModalContainer'
import Buttons from 'components/_new/modal/DialogModal/Buttons/Buttons'
import Headline from 'components/_new/typography/deprecated/Headline/Headline'
import Overlay from 'components/_new/layout/Overlay/Overlay'
import Modal from 'components/_new/modal/Modal/Modal'
import Image from 'components/_new/ui/Image/Image'

// resolve picture x2
import imageSrc from './images/timeBird.png'


import messages from './messages'
import s from './PutFirstInQueueModal.scss'


const PutFirstInQueueModal = (props) => {
  const {
    title,
    name: modalName,
    data: { productIndex, item: { name, brand, id } = {}, onCancel: _onCancel },
  } = props

  const close = useCallback(() => {
    actions.models.modals.close(constants.modals.limitedEditionProducts.PutFirstInQueue)
  }, [])

  const onCancel = useCallback(() => {
    if (typeof _onCancel === 'function') {
      _onCancel()
    }

    close()
  }, [ _onCancel, close ])

  const handleConfirm = useCallback(() => {
    actions.models.queue.moveToFirstPosition(productIndex, {
      placement: 'limited put first popup',
      name,
      brand,
      id,
    })

    close()
  }, [ productIndex, name, brand, id, close ])

  const leftButtonProps = useMemo(() => ({
    title: messages.cancelButton,
    color: 'transparent',
    onClick: onCancel,
    dataTestId: `${modalName}`,
  }), [ onCancel, modalName ])

  const rightButtonProps = useMemo(() => ({
    title: messages.confirmButton,
    onClick: handleConfirm,
    dataTestId: modalName,
  }), [ modalName, handleConfirm ])

  const footerNode = useMemo(() => (
    <Buttons rightButton={rightButtonProps} leftButton={leftButtonProps} />
  ), [ leftButtonProps, rightButtonProps ])

  return (
    <ModalContainer>
      <Overlay onClick={close} />
      <Modal onClose={close} footerNode={footerNode}>
        <Image {...imageSrc} className={s.image} />
        <Headline
          title={title}
          subTitle={messages.text}
          subTitleClassName={s.subTitle}
          size="lg"
          mutedSubTitle={false}
        />
      </Modal>
    </ModalContainer>
  )
}

PutFirstInQueueModal.propTypes = {
  name: PropTypes.string,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  data: PropTypes.shape({
    productIndex: PropTypes.number.isRequired,
  }),
}

PutFirstInQueueModal.defaultProps = {
  name: constants.modals.limitedEditionProducts.PutFirstInQueue,
  title: messages.title,
}


export default PutFirstInQueueModal
